@if (!dataInLayer || !dataInLayer.length) {
  <app-alert [styleClass]="'m-0 p-2'" [canToggle]="false"
    >Keine Daten enthalten</app-alert
  >
}
@for (item of dataInLayer; track item._id; let first = $first) {
  @if (indicatorStore.getById(item.indicator); as indicator) {
    <div
      [ngClass]="{ 'border-top-1 surface-border': !first }"
      class="flex align-items-center gap-3 p-2">
      <i
        [class]="
          indicator.parent ? 'fas fa-file-import' : 'fas fa-ruler-vertical'
        "></i>
      <span>{{ indicator.name }}</span>
      <app-indicator-detail-button
        class="ml-auto mr-1"
        [indicator]="indicator" />
    </div>
  }
}
